import { isBlank, isPresent } from 'lib/lodash.isblank'

// exportando isBlank() e isPresent() globalmente
window.isBlank = isBlank
window.isPresent = isPresent
